"use client";
import { useEffect } from "react";
import { toast } from "sonner";

export function PwaRegister() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    if (!("serviceWorker" in navigator)) return;

    navigator.serviceWorker.register("/sw.js").then((reg) => {
      reg.addEventListener("updatefound", () => {
        const newWorker = reg.installing;
        newWorker?.addEventListener("statechange", () => {
          if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
            toast.info("Mise à jour disponible", {
              description: "Rechargez la page pour obtenir la dernière version.",
              action: { label: "Recharger", onClick: () => window.location.reload() },
              duration: Infinity,
            });
          }
        });
      });
    }).catch((err) => {
      console.warn("[PWA] Service worker non enregistré :", err);
    });
  }, []);

  return null;
}